import { Component, EventEmitter, Input } from '@angular/core';
import { FormArray, FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MogoDropzoneComponent } from "../../../../../../../shared/mogo-dropzone/mogo-dropzone.component";

@Component({
  selector: 'app-order-documents-form',
  standalone: true,
  imports: [MogoDropzoneComponent, ReactiveFormsModule],
  templateUrl: './order-documents-form.component.html',
  styleUrl: './order-documents-form.component.scss'
})
export class OrderDocumentsFormComponent {
  @Input()
  formGroup!: FormGroup;
  @Input()
  disableEmitter!: EventEmitter<boolean>;

  constructor(private formBuilder: FormBuilder) { }

  ngOnInit() {
    this.disableEmitter.subscribe((value) => {
      if (value) {
        this.formGroup.get('orderDocuments.documents')?.disable({ emitEvent: false });
      } else {
        this.formGroup.get('orderDocuments.documents')?.enable();
      }
    });
    this.initializeForm();
  }

  initializeForm() {
    this.formGroup.addControl('orderDocuments', this.formBuilder.group({
      documents: this.formBuilder.control<File[]>([]),
    }));
  }

  getFormGroup() {
    return this.formGroup.get('orderDocuments') as FormGroup;
  }
}
